module.exports = __webpack_public_path__ + "static/media/Pumudi.e0f73bd4.jpg";